export class Distribution {
  private static _values: Distribution[] = [];
  private static _lookup: Map<number, Distribution> = new Map();

  static fromId(id: number) {
    const instance = Distribution._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Distribution.id: ' + id);
    }
    return instance;
  }

  static values(): Distribution[] {
    return [...Distribution._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Distribution._values.push(this);
    Distribution._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Distribution: ' + this.id + ", label='" + this.label + "'>";
  }
}
